import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * Single app-wide toast host. Mount once at App root — do not remount per page
 * (multiple ToastContainers make toasts appear only after navigation).
 */
const Toastify = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover
      theme="colored"
      limit={5}
      style={{ zIndex: 999999 }}
      toastStyle={{ zIndex: 999999 }}
      className="app-toast-container"
    />
  );
};

export default Toastify;
